// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-grid[data-v-3ed7d178]{background-color:#f8f8f8}.indication-dot[data-v-3ed7d178]{border-radius:50%;display:inline-flex;height:11px;width:11px}.indication-dot__preparing[data-v-3ed7d178]{background-color:#fff}.indication-dot__ready-for-delivery[data-v-3ed7d178]{background-color:#ffcb18}.grid-wrapper[data-v-3ed7d178]{display:flex;margin-right:3px}.order-grid-col[data-v-3ed7d178]{background-color:#ebebeb}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
